import { render, staticRenderFns } from "./placeholder_note.vue?vue&type=template&id=219fe298&vue3"
import script from "./placeholder_note.vue?vue&type=script&lang=js&vue3"
export * from "./placeholder_note.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports